import { cx } from '@emotion/css';
import { RefObject, useCallback, useState } from 'react';

import { useResponsiveSizing } from './hooks';
import {
  actionClassName,
  disabledActionClassName,
  iconClassName,
  leftActionClassName,
} from './styles';

interface Props {
  parentRef: RefObject<$TSFixMe>;
  presentationRef: RefObject<$TSFixMe>;
  children: $TSFixMe;
}

export default function ArrowLeft({
  parentRef,
  presentationRef,
  children,
}: Props) {
  const [isScrolling, setScrolling] = useState(false);
  const sizing = useResponsiveSizing({
    parentRef,
    presentationRef,
    children,
  });

  const handleLeft = useCallback(() => {
    if (isScrolling) return;
    setScrolling(true);
    const { scrollLeft } = parentRef.current;
    const numElapsed = Math.ceil(scrollLeft / sizing.itemWidth) - sizing.limit;
    const willOverflow = numElapsed < 0;
    var distance = willOverflow
      ? scrollLeft - 0
      : scrollLeft - numElapsed * sizing.itemWidth;
    let ref = presentationRef.current;
    ref.style.transform = `translate3d(${distance}px, 0px, 0px)`;
    ref.style.transition = `transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s`;
    setTimeout(() => {
      ref.style.transition = null;
      ref.style.transform = null;
      parentRef.current.scrollLeft -= distance;
      setScrolling(false);
    }, 400);
  }, [isScrolling, parentRef, presentationRef, sizing.itemWidth, sizing.limit]);

  const isDisabled = parentRef.current.scrollLeft <= 0;

  return (
    <div
      className={cx(actionClassName, leftActionClassName, {
        [disabledActionClassName]: isDisabled,
      })}
      dir="left"
      onClick={!isDisabled ? handleLeft : undefined}
    >
      <i className={iconClassName}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
        </svg>
      </i>
    </div>
  );
}
